const today = new Date()
const oldest = new Date()
oldest.setFullYear(oldest.getFullYear() - 120)

// Export date limits for validation
export const DATE_LIMITS = {
  oldest: oldest,
  newest: today
}

const formBlocks = [
  {
    attributes: {
      attachment: {
        type: 'image' as const,
        url: ''
      },
      attachmentMaxWidth: '300px',
      buttonText: 'Get Started',
      description:
        'Did you know there are many connections between your teeth, sleep, weight, blood pressure, diabetes and more?\n' +
        '\n<br>' +
        'Your dentist cares about your overall health and partners with SleepArchitects for your sleep health. This risk assessment will take 2 minutes to complete. Your dentist will discuss your results with you.\n',
      label: 'Welcome!'
    },
    id: 'welcome-screen',
    name: 'welcome-screen'
  },

  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Has anyone told you that you stop breathing while asleep?',
      multiple: false,
      required: true
    },
    id: 'q12',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Have you ever been involved in any type of accident because you nodded off or fell asleep?',
      multiple: false,
      required: true
    },
    id: 'q13',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Have you ever nodded off or fallen asleep while driving?',
      multiple: false,
      required: true
    },
    id: 'q14',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Have you woken up suddenly gasping for air, heart racing or with shortness of breath?',
      multiple: false,
      required: true
    },
    id: 'q15',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Do you grind your teeth?',
      multiple: false,
      required: true
    },
    id: 'q16',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Do you snore or has someone ever told you that you snore?',
      multiple: false,
      required: true
    },
    id: 'q17',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Does anyone in your family have a history of snoring or sleep apnea?',
      multiple: false,
      required: true
    },
    id: 'q18',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Do you feel tired or sleepy throughout the day?',
      multiple: false,
      required: true
    },
    id: 'q19',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Does it take you less than 10 minutes to fall asleep?',
      multiple: false,
      required: true
    },
    id: 'q20',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Does it take you more than 20 minutes to fall asleep?',
      multiple: false,
      required: true
    },
    id: 'q21',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Once you fall asleep, do you have trouble staying asleep?',
      multiple: false,
      required: true
    },
    id: 'q22',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Do you find it difficult to manage your weight?',
      multiple: false,
      required: true
    },
    id: 'q23',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Do you suffer from headaches during the morning or during the night?',
      multiple: false,
      required: true
    },
    id: 'q24',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Have you been diagnosed with high blood pressure or take medication for it?',
      multiple: false,
      required: true
    },
    id: 'q25',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Do you suffer from acid reflux?',
      multiple: false,
      required: true
    },
    id: 'q26',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Do you suffer from heart disease or have you had a stroke?',
      multiple: false,
      required: true
    },
    id: 'q27',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'}
      ],
      label: 'Have you been diagnosed with a sleep disorder?',
      multiple: false,
      required: true
    },
    id: 'q28',
    name: 'multiple-choice'
  },
  {
    attributes: {
      choices: [
        {label: 'Yes', value: 'yes'},
        {label: 'No', value: 'no'},
        {label: 'No CPAP prescribed', value: 'no-cpap'}
      ],
      label: 'Have you stopped using your CPAP device? / Are you wearing it less than 5 times per week?',
      multiple: false,
      required: true
    },
    id: 'q29',
    name: 'multiple-choice'
  },
  {
    attributes: {
      label: "Is there anything else you'd like to share about your sleep?",
      required: false
    },
    id: 'q30',
    name: 'long-text'
  },

  {
    attributes: {
      label: 'Legal First Name',
      required: true
    },
    id: 'q2',
    name: 'short-text'
  },
  {
    attributes: {
      label: 'Legal Last Name',
      required: true
    },
    id: 'q3',
    name: 'short-text'
  },
  {
    attributes: {
      choices: [
        {label: 'Male', value: 'male'},
        {label: 'Female', value: 'female'},
        {label: 'Other', value: 'other'}
      ],
      label: 'What is your gender?',
      multiple: false,
      required: true
    },
    id: 'q4',
    name: 'multiple-choice'
  },
  {
    attributes: {
      description: '',
      label: 'What is your mobile phone number?',
      placeholder: 'e.g. (555) 123-4567',
      regex: '^(\\+?\\d{1}-?\\d{3}-?\\d{3}-?\\d{4}|\\d{10}|\\+\\d{11})$',
      required: true
    },
    id: 'q5',
    name: 'custom-phone-number'
  },
  {
    attributes: {
      description: "We'll never share your email with anyone.",
      label: "What's your email address?",
      required: true
    },
    id: 'q6',
    name: 'email'
  },
  {
    attributes: {
      description: '',
      label: 'What is your date of birth?',
      required: true,
    },
    id: 'q7',
    name: 'date'
  },
  {
    attributes: {
      description: 'Select your height in feet.',
      label: 'Height (Feet)',
      max: 8,
      min: 2,
      required: true,
      step: 1,
      suffix: "'"
    },
    id: 'q9',
    name: 'slider'
  },
  {
    attributes: {
      default: 0,
      description: 'Select additional inches.',
      label: 'Height (Inches)',
      max: 11,
      min: 0,
      step: 1,
      suffix: '"'
    },
    id: 'q10',
    name: 'slider'
  },
  {
    attributes: {
      description: 'Enter your weight in pounds.',
      label: 'Weight',
      required: true,
      suffix: 'lbs'
    },
    id: 'q11',
    name: 'number'
  },

  // {
  //   name: 'short-text',
  //   id: 'q32',
  //   attributes: {
  //     label: 'Insurance Provider',
  //     description: 'Enter the name of your insurance company',
  //     required: true,
  //   },
  // },
  // {
  //   name: 'short-text',
  //   id: 'q33',
  //   attributes: {
  //     label: 'Policy Number',
  //     description: 'Enter your policy number from your insurance card',
  //     required: true,
  //   },
  // },
  {
    attributes: {
      allowedFileTypes: ['image/jpeg', 'image/png', 'image/jpg'],
      backDescription: 'Upload a clear photo of the back of your Medical Insurance card',
      description: 'Upload clear photos of both sides of your Medical Insurance card',
      frontDescription: 'Upload a clear photo of the front of your Medical Insurance card',
      label: 'Medical Insurance Card Upload',
      maxFileSize: 5242880,
      required: false
    },
    id: 'q32',
    name: 'custom-file-upload'
  },
  {
    attributes: {
      description:
        'By tapping the button below, you acknowledge that the information you provided is accurate to the best of your knowledge and you consent to receive care-related communication.',
      label: 'Please sign to confirm your answers',
      required: true
    },
    id: 'q31',
    name: 'custom-signature'
  }
]

// The order answers were submitted in before the questions were reordered.
// The backend receives answers in this order regardless of display order.
export const ANSWER_ORDER = [
  'q2', 'q3', 'q4', 'q5', 'q6', 'q7', 'q9', 'q10', 'q11',
  'q12', 'q13', 'q14', 'q15', 'q16', 'q17', 'q18', 'q19', 'q20', 'q21',
  'q22', 'q23', 'q24', 'q25', 'q26', 'q27', 'q28', 'q29', 'q30',
  'q32', 'q31', 'q8'
]

// Blocks rendered with a custom UI but submitted under their original block
// name, because the backend validates blockName against a fixed list.
export const SUBMITTED_BLOCK_NAMES: Record<string, string> = {
  q31: 'short-text'
}

// q8 (SMS consent) is no longer shown to patients because consent is captured
// upstream. Its answer is still submitted so the payload keeps the same set of
// question IDs it has always had. The object below must match the shape
// @quillforms/renderer-core produces for an answered single-select block.
export const HIDDEN_BLOCK_ANSWERS = {
  q8: {
    blockName: 'multiple-choice',
    isAnswered: true,
    isPending: false,
    isValid: true,
    pendingMsg: undefined,
    validationErr: undefined,
    value: ['agree']
  }
}

export default formBlocks
